import { useMutation, useQueryClient } from 'react-query'
import { QueryNames } from 'Hooks/api/queryNames'
import { toast } from 'react-toastify'
import { updateRecurringAllowance } from 'Services/recurringAllowances'

export const useUpdateUserRecurringAllowanceMutation = () => {
  const queryClient = useQueryClient()

  return useMutation([QueryNames.UpdateUserRecurringAllowance], updateRecurringAllowance, {
    onSuccess: (response) => {
      if (response.success) {
        // Invalidate all recurring allowances queries
        queryClient.invalidateQueries([QueryNames.GetUserRecurringAllowances])
        toast.success('Recurring allowance updated successfully')
      } else {
        toast.error(`Failed to update recurring allowance: ${response.message}`)
      }
    },
    onError: (error: any) => {
      console.error('Recurring allowance update error:', error)
      toast.error('Failed to update recurring allowance')
    }
  })
}
